import { combineReducers } from 'redux';
import userNLPReducers from './UserNlp';
import reportReducers from './report';


export default combineReducers({
  userNLPReducers,
  reportReducers
});
